var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 15V16.2C21.8 17.8802 21.8 18.7202 21.473 19.362C21.1854 19.9265 20.7265 20.3854 20.162 20.673C19.5202 21 18.6802 21 17 21H8.60001C6.91985 21 6.07977 21 5.43804 20.673C4.87355 20.3854 4.41461 19.9265 4.12699 19.362C3.80001 18.7202 3.80001 17.8802 3.80001 16.2V15M17.8 10L12.8 15M12.8 15L7.80001 10M12.8 15V3",
    stroke: "#4C60E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload01);
export default __webpack_public_path__ + "static/media/download-01.8095a5d9111eb9c990904be26c4e85de.svg";
export { ForwardRef as ReactComponent };